import React, {
  ChangeEvent,
  RefObject,
  useEffect,
  useRef,
  useState
} from "react";
import { ButtonDelete, SixPoints } from "../../../../../../assets";
import { useAppDispatch, useAppSelector } from "../../../../../../redux/hooks";
import {
  Baloon,
  ButtonPlus,
  ButtonTrash,
  ImageSixPoints,
  Input
} from "./styles";
import { changedPhoneComponent } from "../../../../../../redux/slices/flowupdates";
import {
  addBotFallBack,
  deleteBotFallback,
  updateDefaultFallBackMessage
} from "../../../../../../redux/slices/bot";
import { InputTextarea } from "primereact/inputtextarea";

interface ITextDefaultFallback {
  botId?: number;
}
export const TextDefaultFallback: React.FC<ITextDefaultFallback> = ({
  botId
}) => {
  const dispatch = useAppDispatch();
  const inputTexts = useAppSelector(
    (state) => state.bot.defaulFallbackMessages
  );
  const [cursorPosition, setCursorPosition] = useState<number>(0);
  const emoji = useAppSelector(
    (state) => state.flowInteractions.valueTextEmoji
  );
  const [updatedText, setUpdatedText] = useState<string>("");

  useEffect(() => {
    if (inputTexts.length > 0) {
      setUpdatedText(inputTexts[0]);
    }
  }, [inputTexts]);

  useEffect(() => {
    if (emoji) {
      const beforeCursor = updatedText.slice(0, cursorPosition);
      const afterCursor = updatedText.slice(cursorPosition);
      const newText = beforeCursor + emoji + afterCursor;
      setUpdatedText(newText);

      dispatch(
        updateDefaultFallBackMessage({
          newMessage: newText,
          idx: inputTexts.findIndex((text) => text === updatedText)
        })
      );
    }
  }, [emoji]);

  const handleUpdate = (e: ChangeEvent<HTMLTextAreaElement>, idx: number) => {
    const newText = e.target.value;
    setUpdatedText(newText);
    dispatch(updateDefaultFallBackMessage({ newMessage: newText, idx }));
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (!e.ctrlKey) {
    } else {
      switch (e.key) {
        case "Enter": {
          e.preventDefault();
          handleAddFallbackMessage();
        }
      }
    }
  };
  const handleAddFallbackMessage = () => {
    dispatch(addBotFallBack());
    dispatch(changedPhoneComponent(true));
  };
  const handleDelete = (idx: number) => {
    dispatch(deleteBotFallback(idx));
    dispatch(changedPhoneComponent(true));
  };

  return (
    <>
      {inputTexts.map((el, index) => (
        <div key={index} css={Baloon}>
          <img css={ImageSixPoints} src={SixPoints} alt="icon-six-points" />
          <InputTextarea
            style={{ width: "100%", border: "none", resize: "none" }}
            autoFocus={true}
            value={el}
            onChange={(e) => handleUpdate(e, index)}
            onKeyDown={handleKeyPress}
            placeholder="Insira sua mensagem de fallback aqui..."
            onKeyUp={(e) => setCursorPosition(e.currentTarget.selectionStart)}
            onClick={(e) => setCursorPosition(e.currentTarget.selectionStart)}
            onSelect={(e) => setCursorPosition(e.currentTarget.selectionStart)}
          />
          <button onClick={handleAddFallbackMessage} css={ButtonPlus}>
            +
          </button>

          {inputTexts?.length > 1 ? (
            <button onClick={() => handleDelete(index)} css={ButtonTrash}>
              <img src={ButtonDelete} alt="icon-button-delete" />
            </button>
          ) : null}
        </div>
      ))}
    </>
  );
};
